import React from "react"
import { Link } from "gatsby"
import * as styles from "./style.module.css"

export default ({ link }) => (
  <Link className={styles.button} to={link || "/#chat"}>
    <i className="icon-left-open-big" />
  </Link>
)
